module.exports = __webpack_public_path__ + "img/logo-locatelli-cropped.d6a0d609.jpg";